import type { IEmployeeApiPort } from '@personnel/application/ports/IEmployeeApiPort';
import type { PinGenerateResponseDto } from '@personnel/application/dtos';

/**
 * Use Case for generating an employee PIN
 *
 * Orchestrates the PIN generation flow by delegating to the API port.
 *
 * @param {Object} props - Use case dependencies
 * @param {IEmployeeApiPort} props.apiPort - Port for API operations
 * @returns {Object} Use case executor with execute method
 *
 * @example
 * const useCase = generateEmployeePinUseCase({ apiPort: employeeRepository });
 * const result = await useCase.execute();
 * console.log(result.pin); // '1234'
 */
export const generateEmployeePinUseCase = (props: { apiPort: IEmployeeApiPort }) => {
  const { apiPort } = props;

  /**
   * Executes the PIN generation
   *
   * @returns {Promise<PinGenerateResponseDto>} Generated PIN response
   */
  const execute = async (): Promise<PinGenerateResponseDto> => {
    return apiPort.generatePin();
  };

  return { execute };
};
